import React from 'react'
import { ArticleCrudData } from 'admin/articleService'
import { NavigationTabs } from 'uiComponents/navigation/tabs'
import { usePermission } from 'admin/hocs'
import { useTranslation } from 'translations'

interface ExternalConfigurationSectionProps {
    accountSlug: string
    productData: ArticleCrudData
    onSave: () => void
    onPublish: () => void
    onUnpublish: () => void
    saveBeforeContinue: (action: 'validity' | 'pricing') => void
}

function ExternalConfigurationSection({
    accountSlug,
    productData,
    saveBeforeContinue,
}: ExternalConfigurationSectionProps) {
    const { t } = useTranslation()
    const { hasPermission } = usePermission()
    const pricingIsSet =
        productData.articleValidationErrors?.length &&
        !productData.articleValidationErrors.includes('pricing_settings_not_configured') &&
        !productData.articleValidationErrors.includes('ouroboros_payment_plans_not_configured')

    const validityIsSet =
        productData.articleValidationErrors?.length &&
        !productData.articleValidationErrors.includes('validity_not_configured')

    const tabs = [
        {
            name: t('products.crud.externalConfigurations.editDetails'),
            onClick: () => {},
            current: true,
            disabled: !hasPermission('partner_admin', accountSlug),
        },
        {
            name: validityIsSet
                ? t('products.crud.externalConfigurations.editValidity')
                : t('products.crud.externalConfigurations.configureValidity'),
            onClick: () => saveBeforeContinue('validity'),
            current: false,
            disabled: !hasPermission('view_product_validity', accountSlug),
        },
        {
            name: pricingIsSet
                ? t('products.crud.externalConfigurations.editPricing')
                : t('products.crud.externalConfigurations.configurePricing'),
            onClick: () => saveBeforeContinue('pricing'),
            current: false,
            disabled: !hasPermission('view_pricing_settings', accountSlug),
        },
    ]

    return (
        <div style={{ marginBottom: '2.5em' }}>
            <NavigationTabs tabs={tabs} />
        </div>
    )
}

export default ExternalConfigurationSection
